import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CalendarComponent from '../../../../appointments/components/CalendarComponent';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import AppointmentLogs from './AppointmentLogs';
import * as actions from '../action';
import * as c from '../constant';

function UpdateAppointmentModal({
  appointmentList,
  getAppointmentsList,
  showAppointment,
  appointmentInfo,
  getAppointmentLogs,
  appointmentLogsList,
  id,
  selectedTransaction,
}) {
  const [selected, setSelected] = useState('');

  useEffect(() => {
    getAppointmentsList({
      order: 'ASC',
    });
    return () => {};
  }, []);

  useEffect(() => {
    getAppointmentLogs(id);
  }, []);

  const onSelectEvent = data => {
    showAppointment(data.id);
    setSelected(data.id);
  };

  /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
  const formatEvents = data => {
    const newArr = [];
    for (let i = 0; i < Object.keys(data).length; i++) {
      if (data[i]) {
        const attrib = data[i].attributes;
        newArr.push({
          id: data[i].id,
          transaction: attrib.system_module,
          available_slots: attrib.available_slot,
          period: attrib.period,
          quota: attrib.quota,
          start: attrib.appointment_date,
          end: attrib.appointment_date,
          title: attrib.system_module,
          consumed: attrib.consumed,
        });
      }
    }
    return newArr;
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="w-100">
        <div className="row">
          <div className="col-md-8">
            <div className="card">
              <div className="row">
                <div className="col-md-12 p-3">
                  <div
                    style={{ height: 'calc(100vh - 180px)', minHeight: 500 }}
                  >
                    <CalendarComponent
                      data={
                        appointmentList.length !== 0
                          ? formatEvents(appointmentList)
                          : []
                      }
                      onSelectEvent={onSelectEvent}
                      selected={appointmentInfo}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <AppointmentLogs
              data={appointmentInfo}
              id={id}
              appointmentLogsList={appointmentLogsList}
              selected={selected}
              selectedTransaction={selectedTransaction}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

UpdateAppointmentModal.defaultProps = {
  id: '',
  selectedTransaction: '',
};

UpdateAppointmentModal.propTypes = {
  appointmentList: PropTypes.instanceOf(Object).isRequired,
  appointmentInfo: PropTypes.instanceOf(Object).isRequired,
  getAppointmentsList: PropTypes.instanceOf(Function).isRequired,
  showAppointment: PropTypes.instanceOf(Function).isRequired,
  getAppointmentLogs: PropTypes.instanceOf(Function).isRequired,
  appointmentLogsList: PropTypes.instanceOf(Array).isRequired,
  id: PropTypes.number,
  selectedTransaction: PropTypes.number,
};

const mapStateToProps = ({ api }) => ({
  appointmentList: _.get(api, `${c.GET_APPOINTMENTS_LIST}.list`) || [],
  appointmentInfo: _.get(api, `${c.SHOW_APPOINTMENTS}.res.data`) || [],
  appointmentLogsList: _.get(api, `${c.GET_APPOINTMENT_LOGS}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(UpdateAppointmentModal);
